import React from 'react';
import './ContactForm.scss';
//import icon from '../../assets/banner/icons/Calling.png';

const ContactForm = () => {


    
    return (
        <form>
            <div className="row">
                <div className="col-lg-6">
                    <div class="form-group">
                        <strong>Clinic Name</strong>
                        <p>Dr Poonam Root Canal Point</p>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div class="form-group">
                        <strong>E-mail Us at </strong>
                        <p>dr.poonam2189@gmail.com</p>
                        {/* <input type="email" class="form-control" placeholder="Enter email address..." /> */}
                    </div>
                </div>
                {/* <div className="col-lg-6">
                    <div class="form-group">
                        <label>Service</label>
                        <select class="form-control">
                            <option>Teeth Whitening</option>
                            <option>Teeth Whitening</option>
                            <option>Teeth Whitening</option>
                            <option>Teeth Whitening</option>
                        </select>
                    </div>
                </div> */}
                <div className="col-lg-6">
                    <div class="form-group">
                        <strong>Whatsapp Us</strong>
                        <p>9302306770</p>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div class="form-group">
                        <strong>Phone no</strong>
                        <p>+91 - 9302306770</p>
                    </div>
                </div>
                {/* <div className="col-lg-12">
                    <div class="form-group">
                        <label for="exampleFormControlTextarea1">Messages</label>
                        <textarea class="form-control" placeholder='Enter your messages...' rows="3"></textarea>
                    </div>
                </div>

                <div className="col-lg-6">
                    <button type="submit" class="btn appointment-btn">Book an appointment</button>
                </div> */}
                {/* <div className="col-lg-6">
                    <div className="appointment-call">
                        <div className='icon'>
                            <img src={icon} alt="icon" />
                        </div>
                        <div className='call-text'>
                            <strong>Phone no</strong>
                            <p>9923138138</p>
                        </div>
                    </div>
                </div> */}
            </div>
        </form>
    );
};

export default ContactForm;